import React, { useState } from "react";
import { Card, CardBody, Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import { Link } from "react-router-dom";
import "./tour-card.css";

const GroupTourInternationalCard = ({ tour }) => {
  const { _id, title, city, photos, price, featured, reviews } = tour;
  const totalRating = reviews?.reduce((acc, item) => acc + item.rating, 0);
  const avgRating =
    totalRating === 0
      ? ""
      : totalRating === 1
      ? totalRating
      : (totalRating / reviews?.length).toFixed(1);

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === photos.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? photos.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = photos.map((photo, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
      >
        <img src={photo} alt={`Slide ${index}`} className="d-block w-100" />
      </CarouselItem>
    );
  });

  return (
    <div className="tour_card">
      <Card>
        <div className="tour_img">
          <Carousel activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators items={photos} activeIndex={activeIndex} onClickHandler={goToIndex} />
            {slides}
            <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
            <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
          </Carousel>
          {featured && <span>Featured</span>}
        </div>
        <CardBody>
          <div className="card_top d-flex align-items-center justify-content-between">
            <span className="tour_location d-flex align-items-center gap-1">
              <i className="ri-map-pin-line"></i> {city}
            </span>
            <span className="tour_rating d-flex align-items-center gap-1">
              <i className="ri-star-fill"></i>
              {avgRating === 0 ? null : avgRating}
              {totalRating === 0 ? (
                "Not rated"
              ) : (
                <span>({reviews?.length})</span>
              )}
            </span>
          </div>
          <h5 className="tour_title">
            <Link to={`/grouptoursinternational/${_id}`}>{title}</Link>
          </h5>
          <div className="card_bottom d-flex flex-column align-items-start mt-3">
            <h5 className="starting_from">
              <span>Starting From</span>
            </h5>
            <h5>
              INR {price} <span>/per person</span>
            </h5>
            <button className="btn booking_btn">
              <Link to={`/grouptoursinternational/${_id}`}>Book Now</Link>
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default GroupTourInternationalCard;
